import React, { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import { api, formatGYD } from "@/lib/api";
import { Money, Path, CalendarCheck, Wallet } from "@phosphor-icons/react";

function Tile({ label, value, sub, testId, icon: Icon, accent }) {
  return (
    <div className={`border-2 border-foreground p-6 ${accent ? "bg-primary" : "bg-card"}`}>
      <div className="flex items-center justify-between">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-foreground/60">{label}</div>
        <Icon size={20} weight="duotone" />
      </div>
      <div className="font-display text-4xl tracking-tighter mt-3" data-testid={testId}>{value}</div>
      {sub && <div className="font-mono text-xs text-foreground/60 mt-1">{sub}</div>}
    </div>
  );
}

export default function EarningsPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/driver/earnings");
        setData(r.data);
      } catch {}
    })();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar active="earnings" />
      <div className="max-w-[1100px] mx-auto px-6 py-10">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-foreground/60">Earnings</div>
        <h1 className="font-display text-4xl tracking-tighter mb-8">Cash collected</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <Tile label="Total Earnings" value={data ? formatGYD(data.total_earnings_gyd) : "—"} sub="All-time cash collected" testId="earnings-total" icon={Wallet} accent />
          <Tile label="Total Trips" value={data?.total_trips ?? "—"} sub="Completed trips" testId="earnings-trips" icon={Path} />
          <Tile label="Today Earnings" value={data ? formatGYD(data.today_earnings_gyd) : "—"} sub="Resets at midnight" testId="earnings-today" icon={Money} />
          <Tile label="Today Trips" value={data?.today_trips ?? "—"} sub="Trips completed today" testId="earnings-today-trips" icon={CalendarCheck} />
        </div>

        <div className="mt-10 border-2 border-foreground p-6 bg-card">
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-foreground/60">Payout</div>
          <div className="font-display text-2xl mt-2">100% cash · paid by rider at drop-off</div>
          <p className="text-foreground/70 mt-2 text-sm">
            RideGY runs on cash only. Riders hand you the exact fare in GYD at the
            end of every trip. There are no platform deductions in this MVP.
          </p>
        </div>
      </div>
    </div>
  );
}
